import { useWorkspaceStore } from '@/store/workspaceStore';
import { ViewportControls } from '@/components/chrome/ViewportControls';
import { Minimap } from '@/components/minimap/Minimap';
import styles from '../SpatialCanvas.module.css';

/**
 * Overlay renderer: screen-space UI drawn above the world and unaffected by the
 * camera. Hosts the empty-field hint and the viewport controls today; guides,
 * selection chrome and the minimap slot in here later.
 */
export const OverlayLayer = () => {
  const isEmpty = useWorkspaceStore((s) => {
    const doc = s.workspaces[s.activeWorkspaceId];
    return !doc || Object.keys(doc.objects).length === 0;
  });
  return (
    <div className={styles.overlay} data-testid="overlay-layer">
      {isEmpty && (
        <p className={styles.empty} data-testid="empty-hint">
          An empty field. Add a note, or drag the background to wander.
        </p>
      )}
      <Minimap />
      <ViewportControls />
    </div>
  );
};
